import React, {useState, useEffect} from 'react';
import {Table, Input, List, Modal, Checkbox, Button, message, Select, Pagination, Divider, Popconfirm} from 'antd';
import {ExclamationCircleOutlined, PaperClipOutlined, ShoppingCartOutlined, SyncOutlined, FileOutlined} from '@ant-design/icons';
import VirtualList from 'rc-virtual-list';
import styles from './layout.module.less'
import SearchForm,{SearchFormItem} from "../../../components/SearchForm";

import store from "./store";
import projectStore from '../project/store'
import {observer} from 'mobx-react';
import lodash from "lodash";
import{http, addVisitLog, history, blobToExcel, deepCopy} from 'libs';
import Action from './Action';

// the hook
import { useTranslation } from 'react-i18next';

const {Search} = Input;

export default observer(function () {
  const {t, i18n} = useTranslation()
  const {quoteRecords} = store


  const [selectKeys, setSelectKeys] = useState([])
  const [selectStatus, setSelectStatus] = useState([])
  const [loading, setLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)
  const [repurchaseLoading, setRepurchaseLoading] = useState(false)
  const [download, setDownload] = useState(false)
  const [visible, setVisible] = useState(false)
  const [handleId, setHandleId] = useState(0)
  const [poId, setPoId] = useState('')
  const [invoiceCode, setInvoiceCode] = useState();
  const [invoiceTitle, setInvoiceTitle] = useState();
  const [remarks, setRemarks] = useState();
  const [invoices, setInvoices] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [activedId, setActivedId] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [ordersIsDisabled, setOrdersIsDisabled] = useState(false);
  const [syncIsDisabled, setSyncIsDisabled] = useState(false);
  const [userType, setUserType] = useState();
  const [activeId, setActiveId] = useState();
  const [downloadLoading, setDownloadLoading] = useState();

  useEffect(() => {
    resetSearch();
    // projectStore.fetchRecords()
    setSelectKeys([]);
    setSelectStatus([]);
    if (localStorage.getItem('userInfo')) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      setUserType(userInfo.userType);
    }
  }, [])

  useEffect(()=>{
    setIsDisabled(lodash.flattenDeep([].concat(selectKeys)).filter(v => v)?.length===0)
  },[selectKeys])

  useEffect(()=>{
    if (store.ids.length===0) {
      setSelectKeys([]);
    }
  },[store.ids])

  const closeItem = (item)=>{
    setCloseLoading(true);
    setActivedId(item.id);
    store.closeOrderItem({itemId:item.id}).finally(()=>{
      setCloseLoading(false);
    })
  }

  const columns = [
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'left',
      width: 150,
      render:(value,info)=>{
        return (<><span className={[styles.badge,!info?.catalogName?.includes('销') ? styles.badgeGhost : '',i18n.language==='en'?styles.autoWidth:''].join(' ')}>
          {t(info?.catalogName?.includes('销')?'购':info?.catalogName?.charAt(0))}
        </span>
        {info.goodsInfo.brand}</>)
      }
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'left',
      width: 150,
      render:(value,info)=>info.goodsInfo.name,
    },
    {
      title: t('货号'),
      dataIndex: 'factoryCode',
      align: 'left',
      width: 100,
      render:(value,info)=>info.goodsInfo.factoryCode,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'left',
      width: 60,
      render:(value,info)=>info.goodsInfo.formats,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      width: 80,
      align: 'left',
      render: (val, info, index) => <div>{info.goodsInfo.price ? info.goodsInfo.price + (info.goodsInfo.type * 1 === 2 ? '元/月' : '元') : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      align: 'left',
      width: 60,
      render: (val,info) => <div>{info.goodsInfo.duration ? info.goodsInfo.duration + '月' : '-'}</div>,
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      width: 60,
      align: 'left',
    },
    {
      title: t('合计'),
      dataIndex: 'totalPrice',
      align: 'left',
      width: 80,
      render: val => <div>{val}元</div>,
    },
    // {
    //   title: t('项目编号'),
    //   dataIndex: 'extra_sn',
    //   width: 90,
    //   align: 'center',
    //   
    //   render:  (val, record, index) => {
    //     let project=projectStore.records.filter(v=>v.id===val*1)
    //     let txt='-'
    //     if(project.length){
    //       txt=project[0]['sn']
    //     }
    //     return <div>{txt}</div>
    //   },
    // },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 100,
      align: 'left',
      render: (val,info) => <div>{info.goodsInfo.period ? info.goodsInfo.period : '-'}</div>,
    },
    {
      title: t('同步状态'),
      dataIndex: 'syncedBlgStatusName',
      align: 'left',
      width: 100,
      // render: val => <div>{val}元</div>,
    },
    {
      title: t('行状态'),
      dataIndex: 'statusName',
      align: 'left',
      width: 80,
      // render: val => <div>{val}元</div>,
    },
    {
      title: t('购物车备注'),
      dataIndex: 'cartRemarks',
      width: 120,
      align: 'left',
      render: (val) => <div>{val}</div>,
    },
    {
      title: t('操作'),
      // dataIndex: 'statusName',
      width: 80,
      fixed: 'right',
      align: 'center',
      render: (val) => {
        return  (
          <Popconfirm disabled={val.status==='11'||val.status==='10'} title="是否确定关闭" okText="确定" cancelText="取消" onConfirm={()=>closeItem(val)}>
            <Button disabled={val.status==='11'||val.status==='10'} loading={activedId===val.id&&closeLoading} danger type="text">关闭</Button>
          </Popconfirm>
        )
      }
    },
  ]
  // // 全选操作
  // const selectAll = (e) => {
  //   let sel = e.target.checked
  //   let arr = []

  //   if (sel) {
  //     filterQuoteRecords.map((item, index) => {
  //       let ids = []
  //       item.goods.map(v => ids.push(v.id))
  //       arr[index] = ids
  //     })
  //   }
  //   setSelectKeys(arr)
  // }

  // 单选操作
  const onSelectChange = (selectedRowKeys, index) => {
    console.log(selectedRowKeys,'selectedRowKeys======',index);
    let keys = deepCopy(selectKeys)
    let statusList = deepCopy(selectStatus)
    let status = [];
    if (selectedRowKeys.length) {
      selectedRowKeys.forEach(itemId=>{
        quoteRecords[index].quoteItems.forEach((item)=>{
          if (item.id===itemId) {
            status.push(item.statusName);
            status.push(item.syncedBlgStatusName);
          }
        })
      })
    }else{
    }
    statusList[index] = status;
    keys[index] = selectedRowKeys
    const allSelectStatus = lodash.flattenDeep([].concat(statusList)).filter(v => v);
    if (allSelectStatus.includes('已关闭')||allSelectStatus.includes('下单成功')) {
      setOrdersIsDisabled(true);
    }else{
      setOrdersIsDisabled(false);
    }
    if (allSelectStatus.includes('已关闭')||allSelectStatus.includes('同步成功')) {
      setSyncIsDisabled(true);
    }else{
      setSyncIsDisabled(false);
    }
    // setOrdersIsDisabled
    setSelectKeys(keys)
    setSelectStatus(statusList)
  }

  const makeRowClassName = (record, index) => {
    return record.disabled ? styles.disabled : ''
  }

  // 下单操作
  const checkOrder = (record) => {
    setHandleId(record.id)
    store.handleId=record.id
    store.handleRecord=record
    history.push('/user/quote/check')
    // setLoading(true)
    // setVisible(true)
  }

    // 下单操作
    const handleSubmit = (record) => {
      store.actionVisible = true;
      Modal.confirm({
        title: '是否生成销售订单？',
        icon: <ExclamationCircleOutlined />,
        onOk() {
          store.checkOrder({id:record.id});
        },
        onCancel() {
        },
      });
    }

  // 关闭操作
  const handleClose = (record) => {
    Modal.confirm({
      title: '是否确认关闭报价单？',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        setHandleId(record.id)
        setLoading(true);
        store.closeOrder({id:record.id}).finally(()=>setLoading(false));
        addVisitLog({
          pageName: '报价单关闭',
          fromPageUrl: window.referrerUrl,
          pageUrl:`${window.location.origin}${history.location.pathname}`,
          eventCode: "CloseQuote",
          eventName: "报价单关闭",
          content: JSON.stringify({quoteId: record.id}),
        })
      },
      onCancel() {
      },
    });
  }

  const handleOk = () => {
    if (!poId) {
      message.warn(t('请输入')+t('PO号')+'！')
      return
    }

    store.checkOrder({quote_id: handleId, po_sn: poId}).then(() => {
      history.push('/user/quote/check')
    }).finally(() => handleCancel)
  }

  const handleCancel = () => {
    setHandleId(0)
    setLoading(false)
    setVisible(false)
  }

  // 同步勃林格
  const getSyncedBlgOrderXml = ()=>{
    setSyncLoading(true);
    let ids = lodash.flattenDeep([].concat(selectKeys)).filter(v => v);
    http.post('/javaApi/front/quote/getSyncedBlgOrderXml', {itemIdList:ids})
        .then(res => {
      if (res.data.code === 999) {
        if (!res.data.result) return;
        const xml2 = JSON.parse(res.data.result);
        setTimeout(() => {
          message.warning('您正在跳转回***系统');
          if (xml2 && xml2.url) {
            const form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', xml2.url);
            const content = document.createElement('textarea');
            content.setAttribute('id', 'cXML-urlencoded');
            content.setAttribute('name', 'cXML-urlencoded');
            content.innerText = xml2.xml;
            form.appendChild(content);
            document.body.appendChild(form);
            form.submit();
          }
        }, 1000);
      }
    }).finally(()=>{
      setSyncLoading(false);
    })
  }

  //再次求购
  const handleRepurchase = ()=>{
    setRepurchaseLoading(true)
    let ids = lodash.flattenDeep([].concat(selectKeys)).filter(v => v);
    http.post('/javaApi/front/quote/againInquiry', {itemIdList:ids})
    .then((res) => {
      history.push('/cart')
    })
    .finally(() => setRepurchaseLoading(false))
  }

  // 合并报价单操作
  const handleMergeQuote = () => {
    let ids = lodash.flattenDeep([].concat(selectKeys)).filter(v => v)

    if (ids.length === 0) {
      message.warn(t('请选择商品')+'！')
      return
    }
    setLoading(true)
    store.mergeQuoteRecords(ids).then(() => {
      message.success(t('报价单合并成功')+'！')
      setSelectKeys([])
    }).finally(() => {
      setLoading(false)
      // setNeedReload(!needReload)
    })
  }

  // 下载报价单
  const handleDownload = (record) => {
    setDownload(true)
    setHandleId(record.id)
    addVisitLog({
      pageName: '报价单下载',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ExportQuote",
      eventName: "报价单下载",
      content: JSON.stringify({quoteId: record.id}),
    })
    http.get('/javaApi/front/export/quoteExcel', {params: {quoteId: record.id}, responseType: 'blob'})
      .then((res) => blobToExcel(res.data, '报价单-' + record.sn + '.xlsx'))
      .finally(() => setDownload(false))
  }

  //下载附件
  const downloadFile = (item)=>{
    setActiveId(item.id);
    setDownloadLoading(true);
    http.post('/javaApi/oss/getFileUrl',{filePath:item.attachmentPath}).then((res)=>{
      window.open(res.data.result)
    }).finally(()=>{
      setDownloadLoading(false);
    })
  }

  const onSearch = (values) => {
    store.spq = values;
    store.quotePage = 1;
    store.quotePageSize = localStorage.getItem('quotePageSize') || 10;
    store.quotePageTotal = 0;
    store.fetchQuoteRecords();
  }

  const resetSearch = ()=>{
    store.quotePage = 1;
    store.quotePageSize = localStorage.getItem('quotePageSize') || 10;
    store.quotePageTotal = 0;
    store.spq = {};
    store.fetchQuoteRecords();
  }


  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          {/* <div className={['steps', styles.steps].join(" ")} data-class={'prev, cur'}>
            <div className="step cur">{t('我的报价单')}</div>
            <div className="step ">{t('填写并核对订单信息')}</div>
            <div className="step ">{t('提交订单')}</div>
          </div> */}
        </div>


        <SearchForm onFinish={onSearch} onReset={resetSearch}>
          <SearchFormItem title={t('产品名称')} name='goodsName' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('报价单编号')} name='sn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          {/* <SearchFormItem title={t('项目编号')} name='extra_sn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          {/* <SearchFormItem title={t('中心号')} name='center_sn' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem> */}
          <SearchFormItem title={t('货号')} name='factoryCode' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('品牌')} name='brand' span={8}>
            <Input autoComplete="off" placeholder={t("请输入")} allowClear/>
          </SearchFormItem>
          <SearchFormItem title={t('同步状态')} name='syncedBlgStatus' span={8}>
            <Select allowClear placeholder="请选择">
              <Select.Option key={-5} value={-5}>未同步</Select.Option>
              <Select.Option key={10} value={10}>已同步</Select.Option>
            </Select>
          </SearchFormItem>
        </SearchForm>

        <div className="mainBox">

          <div className="flex" style={{padding: '16px 0 8px'}}>
            {/* <Checkbox onChange={selectAll} style={{flex: 1, fontSize: 20, paddingLeft: 22}}>{t('全选')}</Checkbox> */}
            <div className='tips'><ExclamationCircleOutlined />若对价格和数量有异议，可以勾选所需行项目后点击再次求购</div>
            <Button 
              onClick={handleRepurchase} 
              size="large" 
              type='primary' 
              disabled={isDisabled}
              icon={<ShoppingCartOutlined />}
              loading={repurchaseLoading}
              >{t('再次求购')}</Button>
            {userType==='BLG'&&<Button 
              onClick={getSyncedBlgOrderXml} 
              size="large" 
              type='primary'
              disabled={isDisabled||syncIsDisabled}
              icon={<SyncOutlined />}
              loading={syncLoading}
              >{t('同步至Webuy')}</Button>}
            <Button 
              onClick={(e) => store.showAction(e,selectKeys)}
              size="large" 
              type='primary' 
              disabled={ordersIsDisabled||isDisabled||userType==='BLG'}
              // className='ghost_btn'
              icon={<FileOutlined />}
              >{t('下单')}</Button>
          </div>

          <List
            header=''
            footer=''
            className='orderList'
            dataSource={quoteRecords}
            split={false}
            pagination={false}
            loading={store.isFetching}
            renderItem={(item, index) => (
              <List.Item>

                <div style={{width: '100%'}}>

                  <div className={styles.innerTitle}>
                    <div>{t('报价单编号')}： {item.sn}</div>
                    {/*<div className={styles.badge}>{item.type * 1 === 1 ? '购' : '租'}</div>*/}
                    {/* <div style={{"margin":"0 24px"}}> */}
                      {/* {t(item.catalogName?.charAt(0)==='销'?'购':item.catalogName?.charAt(0))} */}
                    {/* </div> */}
                    <Divider type="vertical" />
                    <div>{t('求购时间')}： {item['createdAt']}</div>
                    <Divider type="vertical" />
                    <div style={{flex: 1}}>{t('报价单总金额')}： <b style={{color: '#EA514B',fontWeight:'400'}}>￥{item['totalPrice'].toFixed(2)}</b>
                    </div>
                    <div className={styles.fileLink}>
                      {
                        item.attachmentName&&
                        <Button type='text' loading={activeId===item.id&&downloadLoading} onClick={()=>downloadFile(item)}><PaperClipOutlined />{item.attachmentName}</Button>
                      }
                    </div>
                    <Button size="small" type="primary" style={{marginLeft: '16px'}} loading={download&& handleId === item.id}
                            onClick={() => handleDownload(item)}>{t('下载报价单')}</Button>
                    {/* <Button size="small" type="primary" style={{marginLeft: 10}}
                            onClick={(e) => store.showAction(e,item)}
                            disabled={item.status!=='0'}
                            loading={loading && handleId === item.id}>{t('下单')}</Button> */}
                    <Button size="small" danger style={{marginLeft: 10}}
                            disabled={item.status!=='0'}
                            onClick={() => handleClose(item)}
                            loading={loading && handleId === item.id}>{t('关闭')}</Button>
                  </div>
                  <Table className={styles.table}
                         pagination={false}
                         scroll={{x: 1000}}
                        //  bordered
                         rowClassName={makeRowClassName}
                         rowSelection={{
                           selectedRowKeys: lodash.get(selectKeys, index, []),
                           onChange: selectedRowKeys => onSelectChange(selectedRowKeys, index),
                         }}
                         rowKey='id'
                         dataSource={item.quoteItems}
                         columns={columns}/>

                </div>

              </List.Item>
            )}
          />
        {store.actionVisible && <Action/>}
          <div className="pagination_container">
              <Pagination
                showSizeChanger={true}
                showLessItems={true}
                current={store.quotePage}
                pageSize={store.quotePageSize}
                total={store.quotePageTotal}
                showTotal={total => `共 ${total} 条`}
                pageSizeOptions={['10', '20', '50', '100']}
                onChange={store.quotePageChange}
            />
            </div>


        </div>


      </div>

    </React.Fragment>
  )
})
